<template>
<div id="PIGDetail">
    <b-overlay :show="loading" rounded="sm">
        <ValidationObserver ref="FormObserver">
            <div class="card">
                <div class="card-header d-flex customStickyCardHeader align-items-center">
                    <div class="my-auto mr-4 close-btn">
                        <a class="close-sidebar" @click="() => onCloseDetail(true, false)">
                            <i class="icon-close f-14"></i>
                        </a>
                    </div>

                    <div class="title my-auto d-flex w-100 align-items-center">
                        <div class="mr-auto">{{ this.EndProductName }}</div>

                        <a v-if="PIGUrl" class="edit-badge" style="flex: 0 0 auto;"
                        target="_blank" :href="PIGUrl"
                        v-bind:t_label="'EMPBE_PIG_ViewPIGDetail_' + EndProductId">
                            <i class="fa fa-eye"></i>
                            {{ $t("lbl_EMP3_PIG_View") }}
                        </a>
                        <!-- <button
                            v-if="IsUAT"
                            class="edit-badge btn-sync-pig ml-2"
                            @click="btnSyncPIGToFrontEnd_Click"
                            v-bind:t_label="'EMPBE_PIG_btnSyncToFrontEnd'">
                            <i class="fa fa-refresh"></i>
                            {{ $t("Lbl_PIGSyncToFrontEnd") }} (Debug)
                        </button> -->
                    </div>
                    
                    <div class="ml-auto SubmitData">
                        <div>{{ $t("lbl_EMPBE_LastSubmit") }}:</div>
                        <div>{{ this.LastSubmissionDate || "-" }}</div>
                    </div>

                    <div class="my-auto Status" :class="this.Status?.toUpperCase() === 'DRAFT' ? 'REQUIRED' : this.Status">
                        {{ this.Status?.toUpperCase() === 'DRAFT' ? $t('lbl_EMPBE_PIG_REQUIRED') : $t(`lbl_EMPBE_PIG_${this.Status}`) }}
                    </div>
                </div>

                <div class="body">
                    <div class="Parent-Container">
                        <div v-if="isDeadlineMet" class="NoticeAfterDeadline">
                            <div class="SubTitle">
                                {{ $t('lbl_EMPBE_PIG_NoticeAfterDeadline') }}
                            </div>

                            <div class="SubDesc font-bold">
                                {{ $t('lbl_EMPBE_HongKong') }}: (+852) 2811 8897 {{ $t('lbl_EMPBE_TelExt') }} 503 <br>
                                chinaplas@adsale.com.hk <br>
                                {{ $t('lbl_EMPBE_Shanghai') }}: (+86) 21-5187 9766 {{ $t('lbl_EMPBE_TelExt') }} 671 <br>
                                chinaplas@sh.adsale.com.hk
                            </div>
                        </div>
                        
                        <div class="w-100" ref="BasicInfo">
                            <h5 v-b-toggle.divBasicInfo class="font-info mb-3">
                                <i class="icofont" :class="isShowBasicInfo ? 'icofont-caret-down' : 'icofont-caret-right'"></i>
                                <span class="ml-1">{{ $t('lbl_EMPBE_PIG_BasicInfo') }}</span>
                            </h5>
                            <b-collapse id="divBasicInfo" class="mx-2 mb-3" v-model="isShowBasicInfo">
                                <div class="w-100">
                                    <img class="w-100 mw-100 h-auto" :src="`https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/Reminder1_${langLocale}.png?v=20251218`"/>
                                </div>
                                <div class="InfoForm-Section InfoForm-Section-Primary">
                                    <div class="mb-3">
                                        <div class="SubTitle Color-Title-Primary">{{ $t('lbl_EMPBE_EndProductNameFormTitle') }}</div>
                                        
                                        <div class="form-grid mt-2">
                                            <div class="w-100">
                                                <!-- <textbox
                                                    ControlId="ProductNameEn"
                                                    :title="$t('lbl_EMPBE_EndProductNameEng')"
                                                    :disabled="isDelisted"
                                                    max="46"
                                                    v-model="form.endProductNameE"
                                                    CharLimit="CheckEnglishChar"
                                                    :mandatory="$t('lbl_EMPBE_PIG_FieldRequiredMsg')"></textbox> -->

                                                <customtextarea
                                                    rows="2"
                                                    :title="$t('lbl_EMPBE_EndProductNameEng')"
                                                    ControlId="ProductNameEn"
                                                    v-model="form.endProductNameE"
                                                    max="46"
                                                    :disabled="isDelisted"
                                                    :noLengthCheckPopup="true"
                                                    :mandatory="$t('lbl_EMPBE_PIG_FieldRequiredMsg')"
                                                    CharLimit="CheckEnglishChar"
                                                    :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }">
                                                </customtextarea>
                                            </div>
                                            <div class="w-100">
                                                <!-- <textbox ControlId="ProductNameCh"
                                                    :title="$t('lbl_EMPBE_EndProductNameChi')"
                                                    :disabled="isDelisted"
                                                    max="21"
                                                    v-model="form.endProductNameT"
                                                    :mandatory="$t('lbl_EMPBE_PIG_FieldRequiredMsg')"></textbox> -->

                                                <customtextarea
                                                    rows="2"
                                                    :title="$t('lbl_EMPBE_EndProductNameChi')"
                                                    ControlId="ProductNameCh"
                                                    v-model="form.endProductNameT"
                                                    max="21"
                                                    :disabled="isDelisted"
                                                    :noLengthCheckPopup="true"
                                                    :mandatory="$t('lbl_EMPBE_PIG_FieldRequiredMsg')"
                                                    :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }">
                                                </customtextarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <div class="mb-2">
                                            <div class="SubTitle">
                                                {{ $t('lbl_EMPBE_PIG_ApplicationIndustry') }}
                                                <span class="text-danger">*</span>
                                            </div>
                                        </div>
                                        <div class="form-grid mt-2">
                                            <selection :class="'mb-0'"
                                                :disabled="isDelisted"
                                                :mandatory="$t('lbl_EMPBE_PIG_FieldRequiredMsg')"
                                                :clearable="false"
                                                :placeholder="$t('lbl_EMPBE_PIG_SelectAppInd')"
                                                :options="applicationOptions"
                                                v-model="form.galleryCatId"
                                                :searchable="false">
                                            </selection>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="mb-2">
                                            <div class="SubTitle">{{ displayLocAndDisplyNoTitle }}</div>
                                            <div class="SubDesc mt-1" v-html="$t('lbl_EMPBE_PIG_ThemeDesc')"></div>
                                        </div>
                                        <div class="position-relative px-0">
                                            <div class="mt-2 d-flex flex-wrap" style="column-gap: 2rem;">
                                                <div>
                                                    <div class="SubTitle font-14">{{ $t('lbl_EMPBE_PIG_Hall') }}</div>
                                                    <div v-if="displayHall && displayHall.length > 0" class="d-flex Hall-Pills mt-2"> 
                                                        <div v-for="(item, index) in displayHall" :key="index">
                                                            {{ item }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="SubTitle font-14">{{ $t('lbl_EMPBE_PIG_DisplayNo') }}</div>
                                                    <div v-for="displayNo in displayNos" class="Hall-Pills mt-2" :key="displayNo">
                                                        <div>{{ displayNo }}</div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="SubTitle font-14">{{ $t('lbl_EMPBE_PIG_DisplayType') }}</div>
                                                    <div v-for="displayGrade in displayGrades" class="Hall-Pills mt-2" :key="displayGrade">
                                                        <div>{{ displayGrade }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="InfoForm-Section InfoForm-Section-Secondary">
                                    <div class="SubTitle Color-Title-Secondary" v-html=" $t('lbl_EMPBE_PIG_Relate')"></div>
                                    <div class="SubDesc mt-1" v-html="$t('lbl_EMPBE_PIG_Relate_Desc')"></div>
                                    <div class="form-grid mt-3">
                                        <productSelection
                                            v-model="RelatedEmpProduct" :valueId="empProductId" :placeOtherText="$t('lbl_EMPBE_PIG_SelectProd')"
                                            :disabled="isDelisted"
                                            :supplierId="companyid" :usagetype="usagetype" ref="ProductSelection"></productSelection>
                                    </div>

                                    <talkBubble v-if="isShowMatDetailForm" arrow="top" adjustedPostition="3rem">
                                        <template>
                                            <div class="bubble-container">
                                                <div class="SubDesc mt-0">{{ $t("lbl_EMPBE_PIG_MatNameDesc") }}</div>
                                                <div class="form-grid">
                                                    <div>
                                                        <customtextarea rows="2" :title="$t('lbl_EMPBE_PIG_MatEngName')" :isShowTitle="false" ControlId="MatNameEn"
                                                            v-model="form.matNameE" max="70"
                                                            :disabled="isDelisted"
                                                            :noLengthCheckPopup="true"
                                                            :mandatory="$t('lbl_EMPBE_PIG_FieldRequiredMsg')"
                                                            :subTitle="$t('lbl_EMPBE_PIG_MatEngName')"
                                                            :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }">
                                                        </customtextarea>
                                                    </div>

                                                    <div>
                                                        <customtextarea rows="2" :title="$t('lbl_EMPBE_PIG_MatChiName')" :isShowTitle="false" ControlId="MatNameCh"
                                                            v-model="form.matNameT" max="35"
                                                            :disabled="isDelisted"
                                                            :noLengthCheckPopup="true"
                                                            :mandatory="$t('lbl_EMPBE_PIG_FieldRequiredMsg')"
                                                            :subTitle="$t('lbl_EMPBE_PIG_MatChiName')"
                                                            :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }">
                                                        </customtextarea>
                                                    </div>
                                                </div>
                                                <div class="SubDesc">{{ $t("lbl_EMPBE_PIG_MatDescDesc") }}</div>
                                                <div class="form-grid">
                                                    <div>
                                                        <customtextarea rows="4" :title="$t('lbl_EMPBE_PIG_MatEngDesc')" :isShowTitle="false" ControlId="MatDescEn"
                                                            v-model="form.matDescE" max="150"
                                                            :disabled="isDelisted"
                                                            :noLengthCheckPopup="true"
                                                            :mandatory="$t('lbl_EMPBE_PIG_FieldRequiredMsg')"
                                                            :subTitle="$t('lbl_EMPBE_PIG_MatEngDesc')"
                                                            :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }">
                                                        </customtextarea>
                                                    </div>

                                                    <div>
                                                        <customtextarea rows="4" :title="$t('lbl_EMPBE_PIG_MatChiDesc')" :isShowTitle="false" ControlId="MatDescCh"
                                                            v-model="form.matDescT" max="50"
                                                            :disabled="isDelisted"
                                                            :noLengthCheckPopup="true"
                                                            :mandatory="$t('lbl_EMPBE_PIG_FieldRequiredMsg')"
                                                            :subTitle="$t('lbl_EMPBE_PIG_MatChiDesc')"
                                                            :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }">
                                                        </customtextarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </talkBubble>
                                </div>
                            </b-collapse>
                        </div>

                        <div class="w-100" ref="OfflineInfo">
                            <h5 v-b-toggle.divOfflineInfo class="font-info d-flex mb-3 align-items-center">
                                <i class="icofont h-100" :class="isShowOfflineInfo ? 'icofont-caret-down' : 'icofont-caret-right'"></i>
                                <span class="ml-1 h-100">{{ $t('lbl_EMPBE_PIG_ExhInfoOfflineShow') }}</span>
                                <span class="ml-2 h-100 deadline-badge text-white" 
                                    :class="{
                                        'bg-gray': isDeadlineMet,
                                        'bg-theme-red': !isDeadlineMet
                                    }">
                                    {{ deadline }}
                                </span>
                            </h5>
                            <b-collapse id="divOfflineInfo" class="mx-2 mb-3" v-model="isShowOfflineInfo">
                                <div>
                                    <div class="SubTitle">{{ $t('lbl_EMPBE_PIG_DisplaySpaceType', { displaySpace }) }}</div>
                                    <div class="SubDesc mt-1" v-html="$t('lbl_EMPBE_PIG_DisplaySpaceTypeDesc')"></div>
                                    <div>
                                        <img class="SizeImg" :src="ReturnWeightOfExhibit" />
                                    </div>

                                    <div class="SubTitle">{{ $t('lbl_EMPBE_PIG_SizeAndWeightOfExhibit', { displayNo }) }}</div>
                                    <div class="SubDesc mt-1" v-html="$t('lbl_EMPBE_PIG_SizeAndWeightOfExhibitDesc')"></div>
                                    <div class="size-container">
                                        <textbox ControlId="Height" :title="$t('lbl_EMPBE_PIG_HeightUnit')"
                                            :disabled="isDelisted || isDeadlineMet"
                                            v-model="form.height"
                                            type="number"
                                            :mandatory="isDeadlineMet ? null : $t('lbl_EMPBE_PIG_FieldRequiredMsg')"></textbox>
                                        <textbox ControlId="Width" :title="$t('lbl_EMPBE_PIG_WidthUnit')"
                                            :disabled="isDelisted || isDeadlineMet"
                                            v-model="form.width"
                                            type="number"
                                            :mandatory="isDeadlineMet ? null : $t('lbl_EMPBE_PIG_FieldRequiredMsg')"></textbox>
                                        <textbox ControlId="Depth" :title="$t('lbl_EMPBE_PIG_DepthUnit')"
                                            :disabled="isDelisted || isDeadlineMet"
                                            v-model="form.depth"
                                            type="number"
                                            :mandatory="isDeadlineMet ? null : $t('lbl_EMPBE_PIG_FieldRequiredMsg')"></textbox>
                                        <textbox ControlId="Weight" :title="$t('lbl_EMPBE_PIG_WeightUnit')"
                                            :disabled="isDelisted || isDeadlineMet"
                                            v-model="form.weight"
                                            type="number"
                                            :mandatory="isDeadlineMet ? null : $t('lbl_EMPBE_PIG_FieldRequiredMsg')"></textbox>
                                    </div>
                                </div>
                                <div>
                                    <div class="SubTitle">{{ $t('lbl_EMPBE_PIG_AdditionalNotes') }}</div>
                                    <div class="SubDesc mt-1" v-html="$t('lbl_EMPBE_PIG_AdditionalNotesDesc')"></div>
                                    <div class="mt-2">
                                        <!-- <textbox ControlId="AdditionalNotes"
                                            :disabled="isDelisted || isDeadlineMet"
                                            v-model="form.additionalNotes" :isHideStar="true"
                                            :placeholder="$t('lbl_EMPBE_PIG_AdditionalNotesPlaceholder')"></textbox> -->

                                        <customtextarea
                                            ControlId="AdditionalNotes"
                                            v-model="form.additionalNotes"
                                            :placeholder="$t('lbl_EMPBE_PIG_AdditionalNotesPlaceholder')"
                                            :disabled="isDelisted || isDeadlineMet"
                                            rows="1"
                                            :maxHeight="200"
                                            :isShowTitle="false"
                                            :noLengthCheckPopup="true">
                                        </customtextarea>
                                    </div>
                                </div>
                                <div>
                                    <div class="SubTitle">{{ $t('lbl_EMPBE_PIG_IsWithSample') }}</div>
                                    <switchIput :disabled="isDelisted || isDeadlineMet" class="mt-2" ControlId="IsWithSample" v-model="form.isWithSample">
                                    </switchIput>
                                </div>
                                <div>
                                    <div class="SubTitle">
                                        {{ $t('lbl_EMPBE_PIG_ReturnExh') }}
                                        <span class="text-danger">*</span>
                                    </div>
                                    <div class="SubDesc mt-1" v-html="$t('lbl_EMPBE_PIG_ReturnExhDesc')"></div>
                                    <div class="form-grid mt-2">
                                        <selection :class="'mb-0'"
                                            :disabled="isDelisted || isDeadlineMet"
                                            :mandatory="isDeadlineMet ? null : $t('lbl_EMPBE_PIG_FieldRequiredMsg')"
                                            :clearable="false"
                                            :options="[
                                                { id: 'NO', label: $t('lbl_EMPBE_PIG_ReturnOptionNo') },
                                                { id: 'END', label: $t('lbl_EMPBE_PIG_ReturnOptionEnd') },
                                                { id: 'YES', label: $t('lbl_EMPBE_PIG_ReturnOptionYes') },
                                            ]"
                                            :placeholder="$t('lbl_EMPBE_PleaseSelect')"
                                            v-model="form.returnStatus"
                                            :searchable="false">
                                        </selection>
                                    </div>
                                    <talkBubble v-if="isReturn" arrow="top" adjustedPostition="3rem">
                                        <template>
                                            <div class="bubble-container">
                                                <div>
                                                    <div class="SubTitle mb-2 mt-0">{{ $t('lbl_EMPBE_PIG_ReturnAddress') }}</div>

                                                    <div class="d-flex flex-column gap-1">
                                                        <textbox ControlId="ReturnAddress1" :title="$t('lbl_EMPBE_PIG_ReturnAddress1')"
                                                            :disabled="isDelisted || isDeadlineMet"
                                                            v-model="form.returnAddress1"></textbox>
                                                        <textbox ControlId="ReturnAddress2" :title="$t('lbl_EMPBE_PIG_ReturnAddress2')"
                                                            :disabled="isDelisted || isDeadlineMet"
                                                            v-model="form.returnAddress2"></textbox>
                                                        <textbox ControlId="ReturnAddress3" :title="$t('lbl_EMPBE_PIG_ReturnAddress3')"
                                                            :disabled="isDelisted || isDeadlineMet"
                                                            v-model="form.returnAddress3"></textbox>
                                                        <div class="form-grid">
                                                            <textbox ControlId="ReturnPostalCode" :title="$t('lbl_EMPBE_PostalCode')"
                                                                :disabled="isDelisted || isDeadlineMet"
                                                                v-model="form.returnPostalCode"
                                                                CharLimit="CheckEnglishChar"></textbox>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div class="SubTitle mb-2">{{ $t('lbl_EMPBE_PIG_ReturnContact') }}</div>
                                                    <div class="d-flex flex-column gap-1">
                                                        <div class="form-grid">
                                                            <textbox ControlId="ReturnContactName" :title="$t('Lbl_ContactName')"
                                                                :disabled="isDelisted || isDeadlineMet"
                                                                v-model="form.returnContactName"></textbox>
                                                        </div>

                                                        <div class="form-grid">
                                                            <selection :class="'mb-0'"
                                                                :disabled="isDelisted || isDeadlineMet"
                                                                :options="countryOptions"
                                                                :isShowTitle="true"
                                                                :title="$t('lbl_inquiry_tel_countryCode')"
                                                                v-model="form.returnCountryID_eForm" >
                                                            </selection>
                                                            <!-- <textbox ControlId="ReturnAreaCode" :title="$t('lbl_EMPBE_AreaCode')"
                                                                v-model="form.returnAreaCode"></textbox> -->
                                                            <textbox ControlId="ReturnMobileNo" :title="$t('lbl_Mobile')"
                                                                :key="`ReturnMobileNo_${form.returnCountryID_eForm}`"
                                                                :disabled="isDelisted || isDeadlineMet || !form.returnCountryID_eForm"
                                                                :mandatory="form.returnCountryID_eForm > 0 ? `${this.$t('Lbl_PleaseEnter')}${langId === '1252' ? ' ' : ''}${this.$t('lbl_Mobile')}` : null"
                                                                type="number"
                                                                v-model="form.returnMobileNo"></textbox>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </talkBubble>
                                </div>
                                <div>
                                    <div class="SubTitle">{{ $t('lbl_EMPBE_PIG_ExhContactInfo') }}</div>
                                    <div class="form-grid mt-2">
                                        <textbox ControlId="ContactName" :title="$t('Lbl_ContactPersonName')"
                                            :disabled="isDelisted || isDeadlineMet"
                                            v-model="form.contactName"
                                            :isByPassPermission="true"
                                            :mandatory="isDeadlineMet ? null : $t('lbl_EMPBE_PIG_FieldRequiredMsg')"></textbox>
                                    </div>
                                    <div class="form-grid mt-3">
                                        <selection :class="'mb-0'"
                                            :disabled="isDelisted || isDeadlineMet"
                                            :options="countryOptions"
                                            :isShowTitle="true"
                                            :title="$t('lbl_inquiry_tel_countryCode')"
                                            v-model="form.countryID_eForm"
                                            :mandatory="isDeadlineMet ? null : $t('lbl_EMPBE_PIG_FieldRequiredMsg')">
                                        </selection>
                                        <!-- <textbox ControlId="AreaCode" :title="$t('lbl_EMPBE_AreaCode')"
                                            v-model="form.areaCode"></textbox> -->
                                        <textbox ControlId="MobileNo" :title="$t('lbl_Mobile')"
                                            :key="`MobileNo_${form.countryID_eForm}`"
                                            :disabled="isDelisted || isDeadlineMet || !form.countryID_eForm"
                                            :mandatory="isDeadlineMet ? null : form.countryID_eForm > 0 ? `${ this.$t('Lbl_PleaseEnter')}${langId === '1252' ? ' ' : ''}${this.$t('lbl_Mobile')}` : null"
                                            type="number"
                                            v-model="form.mobileNo"></textbox>
                                    </div>
                                    <div class="form-grid mt-3">
                                        <textbox ControlId="Email" :title="$t('Lbl_EmailAddress')"
                                            :disabled="isDelisted || isDeadlineMet"
                                            v-model="form.email"
                                            type="email"
                                            CharLimit="CheckEnglishChar"
                                            :mandatory="isDeadlineMet ? null : $t('lbl_EMPBE_PIG_FieldRequiredMsg')"></textbox>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>

                        <div class="w-100" ref="OnlineInfo">
                            <h5 v-b-toggle.divOnlineInfo class="font-info mb-3">
                                <i class="icofont" :class="isShowOnlineInfo ? 'icofont-caret-down' : 'icofont-caret-right'"></i>
                                <span class="ml-1">{{ $t("lbl_EMPBE_PIG_ExhInfoEMP") }}</span>
                            </h5>
                            <b-collapse id="divOnlineInfo" class="mx-2 mb-3" v-model="isShowOnlineInfo">
                                <img class="w-100 h-auto mb-3" :src="`https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/Reminder2_${langLocale}.png`"/>
                                <div class="Img-Tag-Preview">
                                    <div class="Img-Tag-Wrapper InfoForm-Section" ref="ImageUpload">
                                        <div class="SubTitle-Wrapper">
                                            <div class="SubTitle Color-Title-Primary">
                                                {{ exhibitImgTitle }}
                                                <span class="text-danger">*</span>
                                                <span class="lblPhotoEdit" @click="()=>{ $refs.PIGImgListUploader.openEditModalWithMediaId(PIGImgList?.[0]?.id); }">
                                                    <img :src="cdnURL_Product+'Edit.svg'" class="textlengthdrop-img"/> 
                                                    {{ $t("lbl_EMPBE_Edit") }}
                                                </span>
                                            </div>
                                            <div class="SubDesc" v-html="$t('lbl_EMPBE_PIG_ExhibitImages_Desc')">                          
                                            </div>
                                        </div>
                                        <mediaUploader
                                            :isShowCover="true"
                                            mediaType="image"
                                            :MediaArray="PIGImgList"
                                            :limit="5"
                                            :maxSize="5"
                                            :aspectRatioStr="'1:1'"
                                            :isRequired="true"
                                            :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                                            galleryItemStyle="height: 90px; width: 90px;"
                                            fileUsageType="EndProductImage"
                                            filePathEndpoint="Image"
                                            @update="(cmd, files, imgBtnArr) => handlerUploaderUpdateData(cmd, files, imgBtnArr)"
                                            ref="PIGImgListUploader"
                                        />
                                        <div class="SubTitle-Wrapper">
                                            <div class="SubTitle">
                                                {{ $t('lbl_EMPBE_PIG_ExhibitHighlightTag') }}
                                                <span class="text-danger">*</span>
                                            </div>
                                            <div v-if="form.galleryCatId" class="SubDesc" v-html="$t('lbl_EMPBE_PIG_ExhibitHighlightTag_Desc')"></div>
                                            <div v-else class="SubDesc" v-html="$t('lbl_EMPBE_PIG_PlsSelectApp')"></div>
                                        </div>
                                        <div v-if="form.galleryCatId" class="Captions-Wrapper">
                                            <MultiToggle
                                                :ButtonList="GetButtonList"
                                                :SelectedId="form.captionIds"
                                                :disabled="isDelisted"
                                                :Max="3"
                                                v-model="form.captionIds"
                                                @update:value="newValue => form.captionIds = newValue"></MultiToggle>
                                        </div>
                                    </div>
                                    <div class="Preview-Wrapper">
                                        <div class="Preview-Box flex-column">
                                            <div class="top-tool w-100 d-flex ">
                                                <div class="my-auto Preview-Title">{{ $t('lbl_EMPBE_PIG_Preview') }}</div>
                                                <div class="ml-auto my-auto flex-row d-flex gap-2">
                                                    <div class="d-flex">
                                                        <label class="my-auto" for="EN">
                                                            <span class="LangRadio" :class="IsEngPreview ? 'Active' : ''">EN</span></label>
                                                        <input v-model="IsEngPreviewStr" 
                                                        id="EN" type="radio" class="hidden" value="true" name="language">
                                                    </div>
                                                    <div class="d-flex">
                                                        <label  class="my-auto" for="CHI">
                                                            <span class="LangRadio" :class="IsEngPreview ? '' : 'Active'">中</span></label>                      
                                                        <input v-model="IsEngPreviewStr" 
                                                        id="CHI" type="radio" class="hidden" value="false" name="language">
                                                    </div>
                                                </div>
                                            </div>
                                            <a class="Preview-Img position-relative" @mouseover="IsHover = PIGUrl ? true : false" :href="PIGUrl" target="_blank"
                                                @mouseleave="IsHover = false " :style="{ cursor: PIGUrl ? 'pointer' : 'default' }" v-bind:t_label="'EMPBE_PIG_PreviewPIGDetail_' + EndProductId">
                                                <img v-if="GetExhibitImage" :key="updateImageCount" class="ExhibitImg" :src="GetExhibitImage">
                                                <div class="Img-Empty" :class="{ 'bg-white': !!GetExhibitImage }">
                                                    <img class="HarmonyBackground"
                                                        v-if="GetExhibitImage"
                                                        :key="updateImageCount"
                                                        :src="GetExhibitImage">
                                                    <img v-if="!GetExhibitImage" :key="updateImageCount" src="https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/Image.png">
                                                </div>
                                                <div v-if="IsHover" class="HoverImg w-100 h-100 d-flex"> 
                                                    <div v-if="!IsEngPreview" class="my-auto mx-auto Explore d-flex">探索 <img class="m-auto" src="../../../assets/customSVG/Arrow_R.svg"></div>
                                                    <div v-if="!IsEngPreview" class="d-flex mt-auto EndProductName ">
                                                        <div  class="cut-text-2">{{form.endProductNameT}}</div>
                                                    </div>
                                                    
                                                    <div v-if="IsEngPreview" class="my-auto mx-auto Explore d-flex">Explore <img class="m-auto" src="../../../assets/customSVG/Arrow_R.svg"></div>

                                                    <div  v-if="IsEngPreview"  class="d-flex mt-auto EndProductName ">
                                                        <div class="cut-text-2">{{form.endProductNameE}}</div>
                                                    </div>

                                                </div>
                                                <div v-if="!IsHover" class="Exhibit-Tag">
                                                    {{GetExhibiHighlightTag}}
                                                </div>
                                            </a>

                                        </div>
                                                                    
                                        <div class="SubTitle-Wrapper">
                                            <div class="SubDesc font-weight-bold" v-html="$t('lbl_EMPBE_Preview_TipsTitle')">
                                            </div>
                                            <div class="SubDesc" v-html="$t('lbl_EMPBE_Preview_Tips')">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>

    </b-overlay>

    <div v-if="!isDelisted" class="customizer-formbutton">
                <b-button-group>
                    <!-- <button type="button" class="btn btn-lightgray btn-lg" @click="Delist()"
                    v-bind:t_label="'EMPBE_PIG_btnDelist'" >
                    {{ $t("lbl_EMPBE_Delist") }}
                  </button> -->
                  <button type="button" class="btn btn-primary btn-lg" @click="() => Save(false)"
                    v-bind:t_label="'EMPBE_PIG_btnSave'" >
                    <i class="fa fa-save m-r-5"></i>{{ $t("lbl_EMPBE_Ad_Save_Save") }}
                  </button>
                  <button type="button" class="btn btn-success btn-lg" @click="() => Submit(false)"
                    v-bind:t_label="'EMPBE_PIG_btnSubmit'" >
                    <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_Ad_Submit_Save") }}
                  </button>
                </b-button-group>
    </div>
</div>
</template>

<script>
import { endProductService } from '@/_services/endproduct.service';
import { CompanyInfoService, productService } from "@/_services";
import mediaUploader from '../../../components/form/upload/imgUploader/mediaUploader.vue';
import { mapState } from 'vuex';
import { getInitImageDataObj } from '@/_helpers/media-uploader-utils.js';
import { LogService } from "@/_services/log.Service";

const defaultUploadResult = {
    isSuccessful: true,
    message: "",
    failedItems: [],
};

export default{
    components: {
        mediaUploader
    },
    props: {
        endProductId: {
            type: [String, Number],
            default: null,
        },
        supplierId: {
            type: [String, Number],
            default: null,
        },
        embedded: {
            type: Boolean,
            default: false,
        },
        submitType:{
              type: String ,
               default: 'edit',
        }
    },
    data(){
        return {
            ThrottleControl:false,
            cdnURL_Product: "https://cdn.adsalecdn.com/EMP/Backend/svg/ProductInfo/",
            langid: localStorage.getItem("currentLangId"),
            loading:false,
            IsEngPreviewStr: localStorage.getItem("currentLangId") == "1252" ? 'true' : 'false', // Radio button can only input string
            // Prefer prop (embedded/approval); fall back to route param
            EndProductId: this.endProductId || this.$route.params.id,
            EndProductName: "",
            LastSubmissionDate: "",
            LastUpdatedDate: "",
            Status: "",
            //CaptionData
            Captions:[],
            //Dummy Data for disabled dropdown
            displayHall:[],
            applicationOptions:[],
            countryOptions: [],
            displayNo: "",

            displayGrade: "",
            displaySpaceType: "",
            displaySpace: "",
            firstDisplayDeadline: "",
            secondDisplayDeadline: "",
            realFormLockDeadline: "",

            usagetype: "photo",
            empProductId: null,
            INIT_EMP_PRODUCT_DETAIL: {
                empProductId: null,
            },
            dirty: false,
            form: {
                captionIds: [],
                empCompanyId: this.companyid,
                empProductNameE: "",
                empProductNameS: "",
                empProductNameT: "",
                // endProductDescE: "",
                // endProductDescS: "",
                // endProductDescT: "",
                endProductNameE: "",
                endProductNameS: "",
                endProductNameT: "",
                galleryCatId: "",
                galleryHallId:0,
                isDeleted: false,
                isLaunch: true,
                matNameE: "",
                matNameT: "",
                matNameS: "",
                matDescE: "",
                matDescT: "",
                matDescS: "",
                width: "",
                height: "",
                depth: "",
                weight: "",
                additionalNotes: "",
                contactName: "",
                // areaCode: "",
                mobileNo: "",
                email: "",
                countryID_eForm: 0,
                returnStatus: "",
                returnContactName: "",
                returnCountryID_eForm: "",
                // returnAreaCode: "",
                returnMobileNo: "",
                returnAddress1: "",
                returnAddress2: "",
                returnAddress3: "",
                returnPostalCode: "",
                isWithSample: false,
            },
            //For File Upload
            PIGImgList: [],
            dbUpdateCommandsForMedia: [],
            pendingUploadFilesForMedia: [],
            imgBtnArrForMedia: [],
            updateImageCount: 0,
            uploadResult: { ...defaultUploadResult },

            //Seperate from form to avoid dirty form on render
            RelatedEmpProduct: {},

            ScrollElement : null,
            ErrorWR : "",

            IsHover: false,

            isShowBasicInfo: true,
            isShowOfflineInfo: false,
            isShowOnlineInfo: true,

            initGalleryCat: {
                galleryCatId: "",
                captionIds: [],
            },

            PIGUrl: "",
            syncPIGSkipApproval: false,
        }
    },
    created(){
        this.InitFormData();
    },
    computed:{
        ...mapState("submitFormMessage", { isShowSubmitAlertMessage : "isShowModal" }),

        langLocale() {
            return this.langId === "1252" ? "EN" : this.langId === "950" ? "TC" : "SC";  
        },
        isDelisted() {
            return this.Status?.toUpperCase() === "DELIST";
        },
        displayLocAndDisplyNoTitle() {
            const space = this.langId === "1252" ? " " : "";
            
            return (
                this.$t("lbl_EMPBE_PIG_Hall") +
                space +
                this.$t("lbl_EMPBE_grid_filterAndLogic") +
                space +
                this.$t("lbl_EMPBE_PIG_DisplayNo")
            );
        },
        displayNos() {
            if (!this.displayNo)  {
                return [];
            }

            return this.displayNo.split("|");
        },
        displayGrades() {
            if (!this.displayGrade)  {
                return [];
            }

            return this.displayGrade.split("|");
        },
        isDeadlineMet() {
            const that = this;
            const deadline = this.$moment(that.realFormLockDeadline).utc().utcOffset(8);
            const currDate = this.$moment().utc().utcOffset(8);

            return deadline.isSameOrBefore(currDate);
        },
        ReturnWeightOfExhibit(){
            return `https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/SpaceSize_${this.displaySpaceType}_${this.langLocale}.png`;
        },
        langId() {
            return localStorage.getItem("currentLangId");
        },

        exhibitImgTitle() {
            const count = this.imgBtnArrForMedia.length > 0 ? this.imgBtnArrForMedia.length : this.PIGImgList.length;
            return "A. " + this.$t("lbl_EMPBE_PIG_ExhibitImages") + ` (${count}/5)`;
        },

        deadline() {
            const that = this;
            const currDate = this.$moment().startOf("day");
            const firstDeadline = this.$moment(that.firstDisplayDeadline);
            const secondDeadline = this.$moment(that.secondDisplayDeadline);
            const isBeforeFirstDeadline = currDate.isSameOrBefore(firstDeadline);
            const isBeforeSecondDeadline = currDate.isSameOrBefore(secondDeadline);
            
            const deadlineDate = isBeforeFirstDeadline
                ? {
                      DD: firstDeadline.format("DD"),
                      MMM:
                          this.langId === "1252"
                              ? firstDeadline.format("MMM")
                              : firstDeadline.format("MM"),
                      YYYY: firstDeadline.format("YYYY"),
                  }
                : isBeforeSecondDeadline
                ? {
                      DD: secondDeadline.format("DD"),
                      MMM:
                          this.langId === "1252"
                              ? secondDeadline.format("MMM")
                              : secondDeadline.format("MM"),
                      YYYY: secondDeadline.format("YYYY"),
                  }
                : {
                      DD: secondDeadline.format("DD"),
                      MMM:
                          this.langId === "1252"
                              ? secondDeadline.format("MMM")
                              : secondDeadline.format("MM"),
                      YYYY: secondDeadline.format("YYYY"),
                  };

            return this.isDeadlineMet? this.$t("lbl_EMPBE_PIG_LockedAfterDeadline") : this.$t("lbl_EMPBE_PIG_DeadlineDate", deadlineDate);
        },
        user() {          
            return this.$store.state.authentication.user;
        },
        companyid() {
            const fromProp = Number(this.supplierId);
            if (!isNaN(fromProp) && fromProp > 0) {
                return fromProp;
            }
            return this.user?.empCompanyId;
        },
        GetExhibitImage() {
            if (this.imgBtnArrForMedia.length > 0) {
                return this.imgBtnArrForMedia[0].imgSrc;
            } else if (this.PIGImgList.length > 0) {
                return this.PIGImgList[0].cdnLink;
            }

            return "";
        },
        GetExhibiHighlightTag() {
            const GetLangId = this.IsEngPreview ? 
            1252 : this.langid == 1252 ?
             936 : this.langid;

            if (this.form.captionIds.length) {
                const Caption = this.Captions.find(x => x.Id == this.form.captionIds[0] && x.langId == GetLangId  );
                if (Caption) {
                    return Caption.Text;
                }
            }
            return GetLangId == 1252? "Highlight tag" : GetLangId == 950 ? "亮點標籤" : "亮点标签";
        },
        GetButtonList() {
            return this.Captions.filter(x => x.langId == this.langid)
        },
        IsEngPreview() {
            return this.IsEngPreviewStr == 'true' ? true : false
        },
        isShowMatDetailForm() {
            return (this.empProductId ?? 0) > 0 || (this.RelatedEmpProduct && this.RelatedEmpProduct.id && this.RelatedEmpProduct.id > 0);
        },
        isReturn() {
            return this.form.returnStatus && this.form.returnStatus.toUpperCase() === "YES";
        }
    },
    methods:{
        uploadFinish(failedFilesFields) {
            const isSuccess = failedFilesFields.length === 0;

            this.uploadResult.isSuccessful = isSuccess;
            this.uploadResult.failedItems = [...this.uploadResult.failedItems, ...failedFilesFields];

            this.$submitFormMessage.FinishUploadPopup({ isSuccess });
        },

        showResultMessagePopup(isSuccess, message, isSubmit) {
            const isSuccessful = isSuccess && this.uploadResult.isSuccessful;
            const uploadFailedItems = this.uploadResult.failedItems;

            this.$submitFormMessage.ShowResultPopup({ isSuccess: isSuccessful, message, isSubmit, uploadFailedItems });
        },

        // [BLK] Only update the stored data arrays for later manipulation
        handlerUploaderUpdateData(commands, pendingFiles, imgBtnArr) {
            this.dbUpdateCommandsForMedia = [...commands];
            this.pendingUploadFilesForMedia = [...pendingFiles];
            this.imgBtnArrForMedia = [...imgBtnArr];

            this.$nextTick(() => {
                if (this.$refs.PIGImgListUploader && this.$refs.PIGImgListUploader.IsRequiredStyle && imgBtnArr.length > 0) {
                    this.$refs.PIGImgListUploader.IsRequiredStyle = false;
                }
                this.updateImageCount = this.updateImageCount + 1;
            });
        },

        LogPageFormError(dataObj, action) {
            LogService.LogFormErrorWithObj(
                {
                    EmpCompanyId: this.companyid,
                    EmpProductId: 0,
                    PageName: this.$route.path.split("/")[1],
                    Action: action,
                },
                {
                    ...dataObj,
                    EndProductId: this.EndProductId,
                }
            );
        },

        resetFilePendingUpdate() {
            this.dbUpdateCommandsForMedia = [];
            this.pendingUploadFilesForMedia = [];
            this.imgBtnArrForMedia = [];
            this.updateImageCount = 0;
        },

        resetFormVerify() {
            this.ErrorWR = "";
            this.ScrollElement = null;
        },

        InitFormData() {
            this.resetFormVerify();
            this.GetByProductId();
            this.GetCountryInfo();
        },
        MapData(Data) {
            this.form.empProductNameE = Data.empProductNameE
            this.form.empProductNameS = Data.empProductNameS
            this.form.empProductNameT = Data.empProductNameT

            this.form.endProductNameE = Data.endProductNameE
            this.form.endProductNameS = Data.endProductNameS
            this.form.endProductNameT = Data.endProductNameT

            // this.form.endProductDescE = Data.endProductDescE
            // this.form.endProductDescS = Data.endProductDescS
            // this.form.endProductDescT = Data.endProductDescT

            this.form.galleryCatId = Data.galleryCatId;
            this.initGalleryCat.galleryCatId = Data.galleryCatId;
            this.form.captionIds = Data.captionIds.length ? Data.captionIds.split("|") : [];
            this.initGalleryCat.captionIds = Data.captionIds.length ? Data.captionIds.split("|") : [];

            this.form.matNameE = Data.matNameE;
            this.form.matNameT = Data.matNameT;
            this.form.matNameS = Data.matNameS;
            this.form.matDescE = Data.matDescE;
            this.form.matDescT = Data.matDescT;
            this.form.matDescS = Data.matDescS;
            this.form.width = this.NumDataConverter(Data.width);
            this.form.height = this.NumDataConverter(Data.height);
            this.form.depth = this.NumDataConverter(Data.depth);
            this.form.weight = this.NumDataConverter(Data.weight);
            this.form.additionalNotes = Data.additionalNotes;
            this.form.contactName = Data.contactName;
            // this.form.areaCode = this.NumDataConverter(Data.areaCode);
            this.form.mobileNo = Data.mobileNo;
            this.form.email = Data.email;
            this.form.countryID_eForm = Data.countryID_eForm;
            this.form.returnStatus = Data.returnStatus;
            this.form.returnContactName = Data.returnContactName;
            this.form.returnCountryID_eForm = Data.returnCountryID_eForm;
            // this.form.returnAreaCode = this.NumDataConverter(Data.returnAreaCode);
            this.form.returnMobileNo = Data.returnMobileNo;
            this.form.returnAddress1 = Data.returnAddress1;
            this.form.returnAddress2 = Data.returnAddress2;
            this.form.returnAddress3 = Data.returnAddress3;
            this.form.returnPostalCode = Data.returnPostalCode;
            this.form.isWithSample = Data.isWithSample;

            this.displayNo = Data.displayNo;
            this.displayGrade = Data.displayGrade;
            this.displaySpaceType = Data.displaySpaceType;
            this.displaySpace = Data.displaySpace;
            this.firstDisplayDeadline = Data.firstDisplayDeadline;
            this.secondDisplayDeadline = Data.secondDisplayDeadline;
            this.realFormLockDeadline = Data.realFormLockDeadline;

            this.empProductId = Data.empProductId;

            if (Data.empProductId) {
                this.INIT_EMP_PRODUCT_DETAIL = {
                    empProductId: Data.empProductId,
                    matNameEn: Data.matNameE,
                    matNameCh: Data.matNameT,
                    matDescEn: Data.matDescE,
                    matDescCh: Data.matDescT,
                };
            }

            //dummy value for disabled selection
            this.displayHall = this.MapHallStrToArr(Data.displayHall);

            this.applicationOptions = Data.applicationOptions;

            this.EndProductName = Data.endProductDisplayName; // || this.$t("lbl_EMPBE_PIG_InputExhibitNameReminder", { exhibitNo: Data.endProductId });
            this.LastSubmissionDate = Data.lastSubmitDate;
            this.LastUpdatedDate = Data.lastUpdatedDate;
            this.Status = Data.status;
           
            this.MapProductImageList(Data.productImageList);
            
            const now = this.$moment();
            const is24HoursLater = Data.lastSubmitDate && now.diff(this.$moment(Data.lastSubmitDate), "hours") >= 24;
            const isShowPIGUrl = Data.status && Data.status.toUpperCase() === "ACTIVE" && is24HoursLater;
            this.PIGUrl = this.isDeadlineMet && isShowPIGUrl ? `${process.env.VUE_APP_EMP_VIEW}productinnovationgallery?Id=${Data.endProductId}` : "";
        },
        MapProductImageList(ImageList) { // Map raw product image list data for image select module
            this.PIGImgList = ImageList.map(image => {
                const id = image.rid;
                const cdnLink = image.fileName;
                const orderId = image.orderId;
                const usageType = image.usageType;
                return getInitImageDataObj(image, { id, cdnLink, orderId, usageType });
            }).sort((a, b) => a.orderId - b.orderId);
        },
        NumDataConverter(data) {
            // data in string or number type
            if (typeof data === "number") {
                return data.toString();
            }

            if (data && data.length > 0) {
                return parseInt(data);
            }

            // data is null or empty string
            return null;
        },
        GetCaptions(currentGalleryCatId) {
            if (!currentGalleryCatId) {
                return;
            }

            //GetCaption langid 0 = get all language
            endProductService.GetCaptions(0, currentGalleryCatId).then(res=>{
                
                //Map data for multi toggle component
                this.Captions = res.data.filter(x=> x.galleryCategoryId == currentGalleryCatId).map(
                    x => ({Id: x.captionId, Text: x.captionText, langId: x.langId})
                )
                      
            })
        },
        GetProductInfo(empProductId) {
            if (!empProductId || empProductId <= 0) {
                return;
            }

            if (this.INIT_EMP_PRODUCT_DETAIL.empProductId && this.INIT_EMP_PRODUCT_DETAIL.empProductId === empProductId) {
                // Assign Initial Value
                this.form.matNameE = this.INIT_EMP_PRODUCT_DETAIL.matNameEn;
                this.form.matNameT = this.INIT_EMP_PRODUCT_DETAIL.matNameCh;
                this.form.matNameS = this.INIT_EMP_PRODUCT_DETAIL.matNameCh;
                this.form.matDescE = this.INIT_EMP_PRODUCT_DETAIL.matDescEn;
                this.form.matDescT = this.INIT_EMP_PRODUCT_DETAIL.matDescCh;
                this.form.matDescS = this.INIT_EMP_PRODUCT_DETAIL.matDescCh;

                return;
            }

            productService.getTempCompanyExhibitDetails({
                companyId: this.companyid,
                ProductId: empProductId,
            }).then((res) => {
                const detail = res.data.tempCompanyExhibit;
                this.form.matNameE = detail.exhibitNameE;
                this.form.matNameT = detail.exhibitNameT;
                this.form.matNameS = detail.exhibitNameT;
                this.form.matDescE = detail.descE;
                this.form.matDescT = detail.descT;
                this.form.matDescS = detail.descT;
            })
        },
        MapHallStrToArr(HallStr) {
            if (!HallStr) {
                return [];
            }
            
            var HallArr = HallStr.split("|")

            return HallArr;
        },
        GetByProductId() {
            this.loading = true
            this.resetFilePendingUpdate();
            endProductService.GetByProductId(this.EndProductId, this.companyid).then(res => {
                this.MapData(res.data);

                this.GetCaptions(res.data.galleryCatId);
            }).finally(() => {
                
                //Product selection component makes the form dirty after fetching data. use delay to wait for it.
                //obsolete! watch $refs.ProductSelection.loaded instead
                const that = this;
                that.loading = false;
                setTimeout(function() {
                    that.dirty = false; 
                }, 500);
            })
        },
        GetCountryInfo() {
            const that = this;
            if (that.countryOptions.length) return;

            CompanyInfoService.GetCellCountryData().then((res) => {
                that.countryOptions = res.map((item) => ({
                    id: item.Code,
                    label: item.Name
                }));
            })
        },
        async Submit(isByPassConfirmPopUp, isByPassSaveDraft = false) {
            if(!isByPassConfirmPopUp && !await this.PopUpConfirmMessage({
                title: this.$t("lbl_EMPBE_Ad_Submit_Title"),
                text: this.$t("lbl_EMPBE_ConfirmToSubmit"),
            })) {
                return
            }
            
            if(!await this.ValidateForm()) {
                this.PrmoptError();
                this.isShowBasicInfo = true;
                this.isShowOfflineInfo = true;
                this.isShowOnlineInfo = true;
                return
            }

            //Do submit action
            try {
                this.loading = true;

                let isUploadSuccess = true;

                if(!isByPassSaveDraft) {
                    isUploadSuccess = await this.Save(true);
                }
                
                if(!isUploadSuccess) {
                    this.loading = false;
                    return
                }

                this.$submitFormMessage.ShowProgressWithoutUploadPopup({ isSubmit: true });

                //Only need to pass EndproductId 
                const res = await endProductService.SubmitEndProduct(
                    {
                        EndProductId: this.EndProductId,
                        EmpCompanyId: this.companyid
                    },
                    this.companyid
                );

                this.loading = false;
                this.$submitFormMessage.NextStepSubmitMessagePopup({ isCurrentStepFailed: !res.isSuccessful });

                if (!res.isSuccessful) {
                    this.LogPageFormError({ res: res }, "Submit_EndProduct");
                    this.showResultMessagePopup(false, "", true);
                    return;
                }
                
                this.SoftReload();
                this.dirty = false;

                this.showResultMessagePopup(true, this.$t("lbl_EMPBE_PIG_SubmitSuccessMsg"), true);

                this.onCloseDetail(true, true);
            } catch(e) {
                this.loading = false;
                console.error(e);
                this.LogPageFormError({ Error: { ErrorMessage: e.message, ErrorName: e.name, ErrorStack: e.stack }}, "Submit_EndProduct");
                this.showResultMessagePopup(false, "", false);
            }
        },
        async Save(ByPassPopUp) {
            if (this.ThrottleControl) return;
            this.ThrottleControl = true;
            this.loading = true;
            
            try {
                const ProductImageList = [];
                const toBeUpdatedLength = this.imgBtnArrForMedia.length;
                const isImageFilledWithoutUpdate = this.PIGImgList.length > 0 && this.dbUpdateCommandsForMedia.length === 0;
                const uploadedRes = await this.fileUploadHandle(false);

                const isUploadToOssSuccessful = this.uploadResult.isSuccessful;
                if (!isUploadToOssSuccessful) {
                    this.loading = false;
                    this.ThrottleControl = false;
                    this.showResultMessagePopup(false, "", false);
                    return;
                }

                if (isImageFilledWithoutUpdate) {
                    this.PIGImgList.forEach((item) => {
                        ProductImageList.push({
                            RID: item.id,
                            FileName: item.cdnLink,
                            OrderId: item.orderId
                        });
                    })
                } else if (toBeUpdatedLength > 0) {
                    this.imgBtnArrForMedia.forEach((item, index) => {
                        const orderId = index + 1;

                        const targetId = item.id;
                        const successedItem = uploadedRes.successfulList.find((i) => i.id === targetId);
                        if (successedItem) {
                            ProductImageList.push({
                                RID: (orderId) * -1,
                                FileName: successedItem.uploadedOssUrl,
                                OrderId: orderId
                            });
                        } else if (!item.isPendingUpload && !uploadedRes.failedList.find((i) => i.id === targetId)) {
                            ProductImageList.push({
                                RID: item.id,
                                FileName: item.imgSrc,
                                OrderId: orderId
                            });
                        }
                    });
                }

                const mappedData = this.MapFormDataForSave();

                const res = await endProductService.DraftEndProduct({ ...mappedData, ProductImageList: ProductImageList }, this.companyid);

                this.loading = false;
                this.ThrottleControl = false;
                this.$submitFormMessage.NextStepSubmitMessagePopup({ isCurrentStepFailed: !res.isSuccessful });

                if (!res.isSuccessful) {
                    this.LogPageFormError({ res: res }, "Save_EndProduct");
                    this.showResultMessagePopup(false, "", false);
                    return false;
                }

                this.SoftReload();
                this.dirty = false;

                if (!ByPassPopUp) {
                    this.$submitFormMessage.HideMessagePopup();

                    const that = this;
                    that.PopUpConfirmMessage({
                        title: that.$t("lbl_EMPBE_SaveSuccess"),
                        text: that.$t("lbl_EMPBE_PIG_SaveSuccessMsg"),
                        confirmButtonText: that.$t("lbl_EMPBE_PIG_SubmitNow"),
                        cancelButtonText: that.$t("lbl_EMPBE_PIG_SubmitLater"),
                    }).then(async (res) => {
                        if (res) {
                            that.Submit(true, true);
                        }
                    });
                }

                return true;
            } catch (err) {
                this.loading = false;
                this.ThrottleControl = false;
                console.error(err);
                this.LogPageFormError({ Error: { ErrorMessage: err.message, ErrorName: err.name, ErrorStack: err.stack }}, "Save_EndProduct");
                this.showResultMessagePopup(false, "", false);
                return false;
            }
        },
        async Delist(){
            this.loading = true;
            endProductService.DelistEndProduct(this.EndProductId, this.companyid).then(async res => {
                this.$submitFormMessage.ShowMesaagePopup({ title: res.isSuccessful ? this.$t("lbl_EMPBE_DelistSuccess") : this.$t("lbl_EMPBE_DelistFailed") });

                if(res.isSuccessful) {
                    this.dirty = false
                    this.SoftReload();
                } else {
                    this.LogPageFormError({ res: res }, "Delist_EndProduct");
                }
            }).catch(err => {
                console.error(err);
                this.$submitFormMessage.ShowMesaagePopup({ title: this.$t("lbl_EMPBE_DelistFailed") });
                this.LogPageFormError({ Error: { ErrorMessage: err.message, ErrorName: err.name, ErrorStack: err.stack }}, "Delist_EndProduct");
            }).finally(() => {
                this.loading = false;
            })
        },
        async ValidateForm() {
            this.resetFormVerify();
            
            if(!await this.IsFillMandatoryInput()) {
                this.ErrorWR = "lbl_EMPBE_IsNotFilledMandatoryInput"
                this.ScrollElement = this.$refs.BasicInfo
                // console.log("Not Yet Filled mandatory Field!")
                return false
            }

            if(!this.IsSelectedRelatedProduct()) {
                this.ErrorWR = "lbl_EMPBE_IsNotSelectedProduct"
                this.ScrollElement = this.$refs.ProductSelection.$el
                // console.log("Not Yet Selected Product")
                return false;
            }

            if(!this.isDeadlineMet && this.IsContactNoHalflyFilled()) {
                this.ErrorWR = "lbl_EMPBE_IsNotFilledContactNo"
                this.ScrollElement = this.$refs.OfflineInfo
                // console.log("Not Yet Filled Contact No with Country!")
                return false
            }

            if(!this.isDeadlineMet && this.isReturn && this.IsReturnContactNoHalflyFilled()) {
                this.ErrorWR = "lbl_EMPBE_IsNotFilledReturnContactNo"
                this.ScrollElement = this.$refs.OfflineInfo
                // console.log("Not Yet Filled Return Contact No with Country!")
                return false
            }

            const isImageFilled = this.IsImageFilled();
            this.$refs.PIGImgListUploader.IsRequiredStyle = !isImageFilled;
            if(!isImageFilled) {
                this.ErrorWR = "lbl_EMPBE_Please_Upload_Photo"
                this.ScrollElement = this.$refs.ImageUpload
                // console.log("Not Yet Filled Image!")
                return false
            }

            if(!this.IsSelectedHighlightTag()) {
                this.ErrorWR = "lbl_EMPBE_IsNotSelectedTag"
                this.ScrollElement = this.$refs.ImageUpload
                // console.log("Not Yet Selected Tags!")
                return false
            }

            return true;
        },
        IsOneOfTheInputFilled(firstParam, secondParam) {
            if ((!firstParam && !secondParam) || (firstParam && secondParam)) {
                return false;
            }

            return true;
        },
        IsContactNoHalflyFilled() {
            return this.IsOneOfTheInputFilled(this.form.mobileNo, this.form.countryID_eForm);
        },
        IsReturnContactNoHalflyFilled() {
            return this.IsOneOfTheInputFilled(this.form.returnMobileNo, this.form.returnCountryID_eForm);
        },
        async IsFillMandatoryInput() {
            //Try Promise
            return new Promise((resolve) => {
                this.$refs.FormObserver.validate(true).then((res) => {
                    resolve(res);
                });
            });
        },
        IsSelectedHighlightTag() {         
            if(this.form.captionIds.length){
                return true
            }
            
            return  false
        },
        IsSelectedRelatedProduct() {   
            if(Array.isArray(this.RelatedEmpProduct)){
                return false // if user selected nothing , it will become empty observer arary
            }
            if(this.RelatedEmpProduct){
                return true
            }
            
            return false
        },
        IsImageFilled() {
            if ((this.PIGImgList.length > 0 && this.dbUpdateCommandsForMedia.length === 0) || this.imgBtnArrForMedia.length > 0) {
                return true
            }
            return false
        },
        MapFormDataForSave() {
            const isEmpProductSelected = this.RelatedEmpProduct && this.RelatedEmpProduct.id > 0;
            const isReturn = this.isReturn;

            const EndProductResult = {
                EndProductId: this.EndProductId,
                EmpCompanyId: this.companyid,
                EmpProductId: isEmpProductSelected ? this.RelatedEmpProduct.id : null,
                EndProductNameE: this.form.endProductNameE,
                EndProductNameS: this.form.endProductNameS,
                EndProductNameT: this.form.endProductNameT,
                // EndProductDescE: this.form.endProductDescE,
                // EndProductDescS: this.form.endProductDescS,
                // EndProductDescT: this.form.endProductDescT,
                Captions: this.form.captionIds.map(x=> ({CaptionId :x})),

                GalleryCatId: this.form.galleryCatId,
                MatNameE: isEmpProductSelected ? (this.form.matNameE ?? "") : null,
                MatNameT: isEmpProductSelected ? (this.form.matNameT ?? "") : null,
                MatNameS: isEmpProductSelected ? (this.form.matNameS ?? "") : null,
                MatDescE: isEmpProductSelected ? (this.form.matDescE ?? "") : null,
                MatDescT: isEmpProductSelected ? (this.form.matDescT ?? "") : null,
                MatDescS: isEmpProductSelected ? (this.form.matDescS ?? "") : null,
                Height: this.NumDataConverter(this.form.height),
                Width: this.NumDataConverter(this.form.width),
                Depth: this.NumDataConverter(this.form.depth),
                Weight: this.NumDataConverter(this.form.weight),
                AdditionalNotes: this.form.additionalNotes,
                IsWithSample: this.form.isWithSample,
                ContactName: this.form.contactName,
                CountryID_eForm: this.form.countryID_eForm,
                // AreaCode: this.NumDataConverter(this.form.areaCode),
                MobileNo: this.form.mobileNo,
                Email: this.form.email,
                ReturnStatus: this.form.returnStatus,
                ReturnContactName: isReturn ? this.form.returnContactName : null,
                ReturnCountryID_eForm: isReturn ? this.form.returnCountryID_eForm : null,
                // ReturnAreaCode: isReturn ? this.NumDataConverter(this.form.returnAreaCode) : null,
                ReturnMobileNo: isReturn ? this.form.returnMobileNo : null,
                ReturnAddress1: isReturn ? this.form.returnAddress1 : null,
                ReturnAddress2: isReturn ? this.form.returnAddress2 : null,
                ReturnAddress3: isReturn ? this.form.returnAddress3 : null,
                ReturnPostalCode: isReturn ? this.form.returnPostalCode : null,
            }

            return EndProductResult;
        },

        fileUploadHandle(isSubmit = false) {
            const pendingFiles = [...this.pendingUploadFilesForMedia];

            return this.$submitFormMessage.FileUploadHandleWithPopup({
                isSubmit,
                pendingFiles,
                commands: [],
                getFailedText: {
                    "EndProductImage": this.$t("lbl_EMPBE_PIG_ExhibitImages")
                },
                uploadFinishCallback: this.uploadFinish
            });
        },
        async PopUpConfirmMessage(swalProps){ // Confirm and Cancel
            return this.$swal({
                showCancelButton: true,
                confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
                cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
                customClass: "ad-svc-popup-save",
                reverseButtons: true,

                ...swalProps,
            }).then(async (res) => {
                return res.isConfirmed
            });
        },
        // async PopUpInfoMessage(swalProps){ // Only Ok
        //     return this.$swal({
        //         confirmButtonText: this.$t("lbl_EMP2_OK"),
        //         customClass: "ad-svc-popup-save",
        //         reverseButtons: true,
                
        //         ...swalProps,
        //         showCancelButton: false, // hide cancel
        //     }).then(async (res) => {
        //         return true
        //     });
        // },
        SoftReload(){
            this.ReloadParent();
            this.InitFormData();
        },
        async PrmoptError(){
            const tKey = this.ErrorWR;
            if (!tKey) return;

            this.showResultMessagePopup(false, this.$t(tKey), true);
            this.ScrollToError();
        },
        ScrollToError(){
            const element = this.ScrollElement;

            if (!element) return;

            let position = this.ScrollElement.getBoundingClientRect();
            var top = position.top + 300;
            setTimeout(() => {
                element.scrollIntoView({ top: top, behavior: "smooth" });
            }, "500");
        },
        ReloadParent(){
            
            if(this.submitType=='approval')
            {
                this.$parent.GetPIGData();
            }else{
                this.$parent.$parent.$parent.GetPIGData();
            }
        },
        async onCloseDetail(isReloadGrid = true, isByPassConfirmPopUp = false) {
            if (isByPassConfirmPopUp) {
                if (isReloadGrid) {
                    this.ReloadParent();
                }

                this.$router.push({
                    name: "PIG",
                });
                return;
            }

            let res = {
                isConfirmed: false,
                isDenied: true, // Default left without saving
                isDismissed: false,
            };

            if (this.dirty) {
                //Show Alert
                await this.$swal({
                    title: this.$t("lbl_EMPBE_PIG_UnsavedChanges"),
                    text: this.$t("lbl_EMPBE_NotSaveLostChanges"),
                    showDenyButton: true,
                    denyButtonText: this.$t("lbl_EMPBE_Discard"),
                    showCancelButton: true,
                    confirmButtonText: this.$t("lbl_EMPBE_Ad_Save_Save"),
                    cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
                    customClass: "ad-svc-popup-save pig-popup",
                    reverseButtons: true,
                }).then((result) => {
                    res = {
                        ...res,
                        ...result
                    };
                });
            }

            // Click Save btn
            if (res.isConfirmed) {
                this.Save(false);
            }

            // Click Discard btn and reload grid required
            if (res.isDenied && isReloadGrid) {
                this.ReloadParent();
            }

            // Click Discard btn
            if (res.isDenied) {
                if (this.embedded) {
                    this.$emit("close");
                    return;
                }
                this.$router.push({
                    name: "PIG",
                });
            }
        },

        AfterHideMessageModal() {
            this.uploadResult = { ...defaultUploadResult };
        },
    },
    watch:{
        endProductId(val) {
            if (val) {
                this.EndProductId = val;
                this.InitFormData();
            }
        },
        isShowSubmitAlertMessage: {
            handler(newValue, oldValue) {
                if (newValue === false && oldValue === true) {
                    this.AfterHideMessageModal();
                }
            }
        },

        "form.countryID_eForm": function(newVal, oldVal) {
            if(!newVal) {
                this.form.mobileNo = "";
            }
        },
        "form.returnCountryID_eForm": function(newVal, oldVal) {
            if(!newVal) {
                this.form.returnMobileNo = "";
            }
        },
        "form.galleryCatId": {
            handler(newVal, oldVal) {
                if (newVal === oldVal) return;

                this.form.captionIds = newVal === this.initGalleryCat.galleryCatId ? this.initGalleryCat.captionIds : []; // Reset if the category is changed
                
                this.GetCaptions(newVal);
            },
            immediate: false,
        },
        "RelatedEmpProduct.id": function(newVal, oldVal) {
            this.GetProductInfo(newVal);
        },
        form: {
            handler(newVal, oldVal) {
                // console.log("catch")
                this.dirty = true;
                this.$store.state.dirty = this.dirty;
            },
            deep: true,
        },
        dirty: {
            handler() {
                this.$store.state.dirty = this.dirty;
            },
        },
        
    },
    // beforeRouteLeave(to, from, next) {
    //     if (this.dirty) {
    //     this.$swal({
    //         //Show Alert
    //         text: this.$t("lbl_EMPBE_LeaveWithoutSaving"),
    //         showCancelButton: true,
    //         confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
    //         confirmButtonColor: "#6e7881",
    //         cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
    //         cancelButtonColor: "#7066e0",
    //     }).then((result) => {
    //         if (result.value) {

    //             next();
    //         } else {
    //         return false;
    //         }
    //     });
    //     } else {
    //         next();
    //     }
    // }
}
</script>

<style lang="scss">
  @import "../style/detail"; 
  //Import Grid for status badege style
  @import "../style/grid"; 

  .SubTitle-Wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .lblPhotoEdit{
    float: right;
    font-size: 14px;
    font-weight: 600;
    color:var(--branding-color-primary-supplier-backend, #7366FF);
    cursor: pointer;
  }

  .btn-sync-pig{
    background: none;
    border: none;
    font-size: 14px;
    font-weight: 600;
    color: #ffc107;
    cursor: pointer;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .btn-sync-pig:hover{
    color: #e0a800;
  }
</style>
